import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#2f5578",
        secondary: "#00c2f3",
        accent: "#7986CB",
        error: "f44336",
        warning: "#44d9ff",
        info: "#2196f3",
        success: "#4caf50"
      }
    }
  }
});
